/*
 * Module for the Job Schedules default View
 */
rs.module("content/jobs/schedules/index",

    ["controls/data/grid"],

    function (gridModule) {

        // Initialize the page
        function initialize(jsSelectors, backendUrl, lrsGridApi) {

            var filter = $.js(jsSelectors.filter);

            var jobSelect = filter.js(jsSelectors.jobSelect);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            if (lrsGridApi) {

                jobSelect.change(function () {

                    loadingSpinner.show();

                    // Update grid
                    gridModule.update(
                        backendUrl,
                        { jobID: this.value },
                        lrsGridApi.agGridApi,
                        function done() {
                            loadingSpinner.hide();
                        }
                    );

                });
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);